<template>
  <v-btn
    flat
    class="text-grey text-caption"
    @click="reset()"
  >
    {{ $t('ResetPassword.ForgotPassword') }}
  </v-btn>
  <SimpleCardDialog
    v-model:dialog="dialog"
    max-width="500"
    :title="$t('ResetPassword.ForgotPassword')"
  >
    <template v-if="isSubmit">
      <div class="mb-3">
        {{ $t('ResetPassword.ForgotPasswordSubmitMessage', {email: formData.email}) }}
      </div>
    </template>

    <template v-else>
      <div class="mb-3">
        {{ $t('ResetPassword.ForgotPasswordMessage') }}
      </div>
      <TextInput
        v-model="formData.email"
        field-key="email"
        :label="$t('User.EmailAddress')"
        required
        type="email"
      />
    </template>

    <template #actions>
      <template v-if="isSubmit===false">
        <ActionButton
          cancel
          @click="close()"
        />
        <ActionButton
          submit
          @click="submit()"
        />
      </template>
      <template v-else>
        <ActionButton
          close
          @click="close()"
        />
      </template>
    </template>
  </SimpleCardDialog>
</template>

<script>
import http from '@/library/no_session_http'
import settings from '@/settings'
import { mapGetters } from 'vuex'
import ActionButton from '@/components/parts/button/ActionButton'
import SimpleCardDialog from '@/components/parts/dialog/SimpleCardDialog'
import TextInput from '@/components/parts/inputs/TextInput'

export default {
  components: { TextInput, SimpleCardDialog, ActionButton },
  data: () => ({
    dialog: false,
    formData: {
      email: ''
    },
    isSubmit: false
  }),
  computed: {
    ...mapGetters(['errorRes', 'ui'])
  },
  methods: {
    reset () {
      this.$store.dispatch('clearErrorRes')
      this.formData = {
        email: ''
      }
      this.isSubmit = false
      this.dialog = true
    },
    submit () {
      http.post(settings.ApiUrl + 'request-reset-password/', this.formData).then(
        (res) => {
          this.isSubmit = true
        }
      )
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.isSubmit = false
      }, 500)
    }
  }
}
</script>

<style scoped>

</style>
